import * as React from 'react'
import { nl2br, targetBlankifyLinks } from '../utils'
import { FormMetadata } from './types'
import { strings } from '../localization'

export function buildParagraph (data: any, metadata: FormMetadata): JSX.Element {
  const formatted = strings.formatString(data.value, {
    agentId: metadata.agentId,
    agentName: metadata.agentName,
    urlencodedAgentName: encodeURIComponent(metadata.agentName)
  }) as string

  let content
  if (data.usesHtml) {
    content = {
      __html: targetBlankifyLinks(formatted)
    }
  } else {
    content = {
      __html: nl2br(targetBlankifyLinks(formatted))
    }
  }

  return <div className={data.className ? data.className : 'col-xs-12'} key={data.qid}><div
    className={'input-line input-paragraph'}
    id={data.qid}
    dangerouslySetInnerHTML={content}>
    </div></div>
}
